// src/services/proveedores/proveedorService.js
import { request } from "../../libs/http/http";

/**
 * Crear nuevo proveedor
 * @param {Object} data - { nombre, nit, email, telefono, nombreContacto, ciudad, direccion, especialidades[], estado, observacion }
 */
export const crearProveedor = (data = {}) => {
  return request('post', '/proveedores/crear', data);
}

/**
 * Listar proveedores con filtros
 * @param {Object} data - Filtros opcionales
 */
export const listarProveedores = (data = {}) => {
  return request('post', '/proveedores/listar', data);
}

/**
 * Paginar proveedores
 * @param {Object} data - { page, limit, filtros... }
 */
export const paginarProveedores = (data = {}) => {
  return request('post', '/proveedores/paginar', data);
}

/**
 * Obtener un proveedor por ID
 * @param {string} id - ID del proveedor
 */
export const obtenerProveedor = (id) => {
  return request('get', `/proveedores/obtener/${id}`);
}

/**
 * Actualizar proveedor
 * @param {string} id - ID del proveedor
 * @param {Object} data - Datos a actualizar
 */
export const actualizarProveedor = (id, data = {}) => {
  return request('put', `/proveedores/actualizar/${id}`, data);
}

/**
 * Eliminar proveedor
 * @param {string} id - ID del proveedor
 */
export const eliminarProveedor = (id) => {
  return request('delete', `/proveedores/delete/${id}`);
}
